"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterPage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const events_1 = require("@front/components/form-parts/events");
const component_1 = require("@front/components/form-parts/form/component");
const events_2 = require("@front/event/events");
const client_1 = require("@rws-framework/client");
const trans_1 = require("../../../../common/translations/trans");
//@ts-ignore                
let rwsTemplate = T.html `
<template>
<div class="fixed-background"
    style="background: url(/assets/images/laptop-5673901_1280.jpg) no-repeat 50% fixed; background-size: cover;">
</div>
<main>
    <div id="firstpages-lang">
        <lang-switcher></lang-switcher>
    </div>
    <div class="container">
        <div class="h-100 row">
            <div class="mx-auto my-auto col-12 col-md-10">
                ${(0, fast_element_1.when)(x => !x.complete, (0, fast_element_1.html) `<div class="auth-card card">
                    <div class="position-relative image-side "
                        style="background:url(/assets/images/keyboard-5017973_1280.jpg); background-size: cover;">
                        <p class="text-white h2">${'register.form.hero.title'.t()}</p>
                        <p class="white mb-0">
                            ${'register.form.hero.description'.t()}
                            <br />${'register.form.hero.login_link_text'.t()} <a @click="${(x, c) => x.goLogin(c.event)}" href="/login">${'register.form.hero.login_link'.t()}</a>
                        </p>
                    </div>
                    <div class="form-side">
                        <a aria-current="page" class="active h4 mb-4 d-block" href="/">
                            ${'app.page.registration_page'.t()}
                        </a>                        
                        <the-form :onSubmit="${(x, c) => x.sendForm.bind(x)}">
                            <part-input required="true" name="name" type="input" label="${'register.nameLabel'.t()}"></part-input>
                            <part-input name="last_name" type="input" label="${'register.lastNameLabel'.t()}"></part-input>
                            <part-input required="true" name="username" type="input" label="${'register.usernameLabel'.t()}"></part-input>
                            <part-input required="true" name="email" type="email" label="${'register.emailLabel'.t()}"></part-input>
                            <part-input required="true" type="password" name="password" label="${'register.passwordLabel'.t()}"></part-input>
                            <part-input required="true" name="repeat_password" type="password" label="${'register.repeatPasswordLabel'.t()}"></part-input>
                            
                            
                            <part-select 
                                required="true" 
                                class="form-part"
                                name="language" 
                                label="${'user.form.language.label'.t()}"
                                :value="${x => x.selectedLanguage}"
                                :options="${x => x.languageOptions}">
                            </part-select>
                            
                            
                            <div class="form-group mt-4">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <label class="form-label mb-0">
                                        <strong>${'register.company.section_title'.t()}</strong>
                                    </label>
                                    ${T.when(x => !x.hasCompanyData, T.html `
                                        <button 
                                            type="button" 
                                            class="btn btn-outline-primary btn-sm"
                                            @click="${(x, c) => x.openCompanyModal()}">
                                            <i class="fas fa-plus mr-1"></i>${'register.company.add_button'.t()}
                                        </button>
                                    `)}
                                </div>
                                
                                ${T.when(x => x.hasCompanyData, T.html `
                                    <div class="card border-success">
                                        <div class="card-body py-3">
                                            <div class="d-flex d-md-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                                                <div class="d-flex align-items-center mb-2 mb-md-0">
                                                    <div class="bg-success rounded-circle p-2 mr-3">
                                                        <i class="fas fa-building text-white"></i>
                                                    </div>
                                                    <div>
                                                        <h6 class="mb-1 font-weight-bold">${x => { var _a; return (_a = x.companyData) === null || _a === void 0 ? void 0 : _a.name; }}</h6>
                                                        <small class="text-muted">${'register.company.data_added'.t()}</small>
                                                    </div>
                                                </div>
                                                <button 
                                                    type="button" 
                                                    class="btn btn-outline-danger btn-sm w-100 w-md-auto"
                                                    @click="${(x, c) => x.removeCompanyData()}">
                                                    <i class="fas fa-times mr-1"></i>${'register.company.remove_button'.t()}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                `)}
                                
                                ${T.when(x => !x.hasCompanyData, T.html `
                                    <div class="text-center py-4 border border-dashed rounded bg-light">
                                        <i class="fas fa-building text-muted mb-2" style="font-size: 2rem;"></i>
                                        <p class="text-muted mb-0">
                                            ${'register.company.optional_help'.t()}
                                        </p>
                                    </div>
                                `)}
                            </div>

                            <div class="d-flex justify-content-end align-items-center">
                                <button 
                                    @click="${(x, c) => x.handleFormSubmit(c.event)}" 
                                    type="submit" 
                                    class="btn-shadow btn btn-primary btn-lg">
                                    ${'register.submit'.t()}
                                </button>
                            </div>
                        </the-form>
                    </div>
                </div>`, (0, fast_element_1.html) `
                <div class="auth-card card">
                    <div class="position-relative image-side "
                        style="background:url(/assets/images/keyboard-5017973_1280.jpg); background-size: cover;">
                        <p class="text-white h2">${'register.complete.hero.title'.t()}</p>
                        <p class="white mb-0">
                            ${'register.complete.hero.description'.t()}
                        </p>
                    </div>
                    <div class="form-side text-center">
                        <div class="mb-4">
                            <div class="success-icon mb-3">
                                <i class="fas fa-check-circle text-success" style="font-size: 4rem;"></i>
                            </div>
                            <h2 class="h4 mb-3">${'register.complete.title'.t()}</h2>
                            <p class="text-muted mb-4">
                                ${'register.complete.description'.t()}
                            </p>
                            <div class="alert alert-info mb-4">
                                <i class="fas fa-envelope mr-2"></i>
                                ${'register.complete.email.check'.t()}
                            </div>
                        </div>
                        
                        <div class="d-flex flex-column gap-3">
                            <button @click="${(x, c) => x.goLogin(c.event)}" class="btn btn-primary btn-lg">
                                <i class="fas fa-sign-in-alt mr-2"></i>
                                ${'register.complete.login.button'.t()}
                            </button>                           
                        </div>                                           
                    </div>
                </div>
                `)}
            </div>
        </div>
    </div>

    
    ${T.when(x => x.showCompanyModal, T.html `
        <div class="modal d-block" style="background-color: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">${'company.form.title.add'.t()}</h5>
                        <button type="button" class="close" @click="${(x, c) => x.showCompanyModal = false}">
                            <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body p-2 p-sm-3">
                        <company-form 
                            external="true">
                        </company-form>
                    </div>
                </div>
            </div>
        </div>
    `)}
</main>
</template>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  height: 100%;
  display: block;
}

#firstpages-lang {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1000;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 5px;
}

main {
  margin: 0 !important;
  height: 100%;
}
main .container {
  height: 100%;
}
main a {
  color: var(--primary-color);
}
main .success-icon {
  animation: successPulse 1.5s ease-in-out;
}
@keyframes successPulse {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
main .gap-3 {
  gap: 1rem;
}

@media (max-width: 768px) {
  .modal .modal-dialog.modal-lg {
    margin: 0.5rem;
    max-width: calc(100% - 1rem);
  }
}
@media (max-width: 576px) {
  .modal .modal-dialog.modal-lg {
    margin: 0.25rem;
    max-width: calc(100% - 0.5rem);
  }
}
@media (max-width: 576px) {
  .modal .modal-content {
    border-radius: 0.25rem;
    border: none;
  }
}
@media (max-width: 576px) {
  .modal .modal-body {
    padding: 0.75rem;
  }
}

@media (max-width: 576px) {
  .company-form-page .btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }
  .company-form-page .btn:last-child {
    margin-bottom: 0;
  }
}
@media (max-width: 576px) {
  .company-form-page .d-flex.justify-content-end {
    flex-direction: column;
  }
  .company-form-page .d-flex.justify-content-end .btn + .btn {
    margin-left: 0;
    margin-top: 0.5rem;
  }
}

@media (max-width: 576px) {
  .company-form-container {
    padding: 0.75rem;
    margin-bottom: 1rem;
  }
}

.border-dashed {
  border-style: dashed !important;
}

.company-section .card {
  transition: all 0.2s ease;
}
.company-section .card.border-success {
  border-color: var(--success) !important;
}
.company-section .bg-success {
  background-color: var(--success) !important;
}
.company-section .btn-outline-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.border-dashed.bg-light {
  background-color: #f8f9fa !important;
  transition: all 0.2s ease;
}
.border-dashed.bg-light:hover {
  background-color: #e9ecef !important;
}

@media (max-width: 576px) {
  .company-section .card-body {
    padding: 0.75rem;
  }
  .company-section .d-flex.justify-content-between {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 0.75rem;
  }
  .company-section .d-flex.justify-content-between .btn {
    align-self: stretch;
    width: 100%;
    margin-top: 0.5rem;
  }
  .company-section .btn-outline-danger {
    width: 100%;
    margin-top: 0.5rem;
  }
  .form-group .d-flex.justify-content-between {
    flex-direction: column;
    align-items: stretch !important;
    gap: 0.75rem;
  }
  .form-group .d-flex.justify-content-between .btn-outline-primary {
    width: 100%;
    margin-top: 0.5rem;
  }
}
@media (max-width: 360px) {
  .card-body {
    padding: 0.5rem !important;
  }
  .card-body .d-flex {
    flex-direction: column !important;
  }
  .card-body .d-flex .btn {
    width: 100% !important;
    margin: 0.25rem 0 !important;
  }
}`;
const shadowOptions = { "mode": "open" };
let RegisterPage = class RegisterPage extends client_1.RWSViewComponent {
    constructor() {
        super();
        this.showCompanyModal = false;
        this.companyData = null;
        this.hasCompanyData = false;
        this.complete = false;
        this.selectedLanguage = (0, trans_1.getCurrentLanguage)();
        this.languageOptions = [
            { label: 'lang.en', value: 'en' },
            { label: 'lang.de', value: 'de' },
            { label: 'lang.es', value: 'es' },
            { label: 'lang.it', value: 'it' },
            { label: 'lang.pl', value: 'pl' },
            { label: 'lang.zh', value: 'zh' }
        ];
        this.sendForm = async function (event) {
            var _a;
            event.preventDefault();
            if (this.fields.password !== this.fields.repeat_password) {
                this.notifyService.notify('user.form.password.repeat.new.label'.t(), 'error');
                return;
            }
            const formData = {
                name: this.fields.name,
                last_name: this.fields.last_name,
                email: this.fields.email,
                username: this.fields.username,
                passwd: this.fields.password,
                repeat_passwd: this.fields.repeat_password,
                language: this.selectedLanguage,
                company: this.hasCompanyData ? this.companyData : undefined
            };
            try {
                const serverResponse = await this.apiService.back.post('auth.register', formData);
                if (serverResponse.success && ((_a = serverResponse.data) === null || _a === void 0 ? void 0 : _a.token)) {
                    console.log('Registration successful, redirecting to registration complete...');
                    this.$emit(events_2.appEvents.logout);
                    this.complete = true;
                }
                else {
                    this.notifyService.notify('user.form.submit.createError'.t() + ': ' + (serverResponse.error || 'popup.error'.t()), 'error');
                }
            }
            catch (error) {
                console.error('Registration error:', error);
                this.notifyService.notify('crud.failedToLoad'.t(), 'error');
            }
        };
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
        this.fields = {
            name: '',
            last_name: '',
            username: '',
            email: '',
            password: '',
            repeat_password: '',
            language: 'en'
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        this.on(events_1.inputEvents.changed, (event) => {
            if (!event.detail.fieldName.includes('.')) {
                this.fields[event.detail.fieldName] = event.detail.element.value;
                console.log('Field changed:', event.detail.fieldName, event.detail.element.value);
            }
        });
        this.on('company-form-submit', (event) => {
            console.log('Company form submitted:', event.detail.company);
            this.companyData = event.detail.company;
            this.hasCompanyData = true;
            this.showCompanyModal = false;
            this.notifyService.notify('company.form.submit.createSuccess'.t(), 'info');
        });
        this.on('company-form-cancel', () => {
            this.showCompanyModal = false;
        });
    }
    sendFormChanged(old, newValue) {
        if (newValue && !old) {
            this.sendForm = newValue.bind(this);
            console.log(this.sendForm);
        }
    }
    openCompanyModal() {
        this.showCompanyModal = true;
    }
    removeCompanyData() {
        this.companyData = null;
        this.hasCompanyData = false;
        this.notifyService.notify('register.company.removed'.t(), 'info');
    }
    goLogin(event) {
        event.preventDefault();
        this.complete = false;
        this.$emit('force-login', { login: true });
    }
    handleFormSubmit(event) {
        this.sendForm.bind(this)(event);
    }
};
exports.RegisterPage = RegisterPage;
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], RegisterPage.prototype, "onRegister", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], RegisterPage.prototype, "showCompanyModal", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], RegisterPage.prototype, "companyData", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], RegisterPage.prototype, "hasCompanyData", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], RegisterPage.prototype, "complete", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], RegisterPage.prototype, "selectedLanguage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], RegisterPage.prototype, "languageOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], RegisterPage.prototype, "sendForm", void 0);
exports.RegisterPage = RegisterPage = __decorate([
    (0, client_1.RWSView)('page-register', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __metadata("design:paramtypes", [])
], RegisterPage);
RegisterPage.defineComponent();
